/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_products.js'
import './_eat.js'

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######
/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 */
scrollValToggle('#header', 500, false, 'active')
scrollValToggle('#spHeader', 300, false, 'active')
scrollValToggle('#fixCart', 700, false, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    if (document.body.classList.contains('js-scrollLock--active')) {
      // スクロール固定中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

//  ##       #####    ####    ##  ##     ##
//  ##      ##   ##  ##       ##  ####   ##
//  ##      ##   ##  ##  ###  ##  ##  ## ##
//  ##      ##   ##  ##   ##  ##  ##    ###
//  ######   #####    ####    ##  ##     ##

if (document.getElementById('page-login')) {
  const tabRecover = document.getElementById('tabRecover')
  const tabLogin = document.getElementById('tabLogin')
  const tabList = document.getElementsByClassName('js-tab')
  tabRecover.addEventListener('click', function (e) {
    for (const iterator of tabList) {
      if (iterator.classList.contains('js-tab--reset')) {
        iterator.style.display = 'block'
      } else {
        iterator.style.display = 'none'
      }
    }
  })
  tabLogin.addEventListener('click', function (e) {
    for (const iterator of tabList) {
      if (iterator.classList.contains('js-tab--login')) {
        iterator.style.display = 'block'
      } else {
        iterator.style.display = 'none'
      }
    }
  })
}

//   ####  ##   ##    ###    ######
//  ##     ##   ##   ## ##     ##
//  ##     #######  ##   ##    ##
//  ##     ##   ##  #######    ##
//   ####  ##   ##  ##   ##    ##
const observeItem = document.body
const observer = new MutationObserver((records) => {
  const frame = records[0].target.querySelector('#shopify-chat iframe')
  if (!frame) {
    return
  }
  console.log(frame)
  setInterval(() => {
    const itemList = frame.contentWindow.document.querySelectorAll(
      '.message-prompt,.assistance-button .outline-button,.composer-bar-form '
    )
    for (const item of itemList) {
      if (item.style.display === 'none') {
        continue
      }
      item.style.display = 'none'
    }
  }, 500)
  observer.disconnect()
})
observer.observe(observeItem, {
  // 指定要素の変化を監視
  childList: true, // 子要素の監視
  subtree: true, // 子孫要素の監視
})
